import React, { Fragment, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppLogoBlack from '../assets/images/logo-black.svg';

function PrivacyPolicy() {

  const history = useHistory()

  useEffect(() => {
    const footer = document.getElementById('footer');
    const header = document.getElementById('header');
    if (history.location.pathname !== '/' && history.location.pathname !== '') {
      footer.style.display = 'none';
      header.style.display = 'none';
    }
    return () => {
      footer.style.display = 'block';
      header.style.display = 'flex';
    }
  }, [])

  return (
    <Fragment>
      <div className='privacyPolicy'>
        <div className='appLogo'>
          <img style={{ cursor: 'pointer'}} onClick={() => {history.push('/')}} src={AppLogoBlack} alt='logo' />
        </div>
        <h2 style={{ marginTop: '30px'}}>Privacy Policy</h2>
        <div>
          <p>
            <a href='https://www.thedoc.pro'>https://www.thedoc.pro</a> website is operated by DOCPRO TECHNOLOGIES PRIVATE LIMITED
          </p>
        </div>
      </div>
    </Fragment>
  );
}

export default PrivacyPolicy;
